module.exports = __webpack_public_path__ + "img/TFT_product_thumbnail.ad228378.png";